import { useCallback, useRef } from 'react'

const emptyCredentials = () => ({
  username: null,
  password: null,
  fbResponse: null,
})

export function usePendingCredentials () {
  const ref = useRef(emptyCredentials())

  const setPendingCredentials = useCallback((patch) => {
    ref.current = { ...ref.current, ...patch }
  }, [])

  const getPendingCredentials = useCallback(() => ref.current, [])

  const clearPendingCredentials = useCallback(() => {
    ref.current = emptyCredentials()
  }, [])

  return {
    setPendingCredentials,
    getPendingCredentials,
    clearPendingCredentials,
  }
}
